/** @jsxImportSource @emotion/react */
import Text from '@Text';
import Box from '@mui/material/Box';
import { css, useTheme } from '@emotion/react';
import Html from '../Html/Html';
import useGetExperimentName from '../../Hooks/useGetExperimentName/useGetExperimentName';

const QuestionText = ({ heading, subheading }) => {
  const theme = useTheme();
  const textExperimentName = useGetExperimentName({
    componentName: 'Text',
  });

  return (
    <>
      <Box
        css={css({
          marginTop: theme.mvf.spacing.medium,
          marginBottom: theme.mvf.spacing.small,
          [theme.breakpoints.up('md')]: {
            maxWidth: theme.breakpoints.values.md,
            marginLeft: 'auto',
            marginRight: 'auto',
          },
        })}
        data-testid="questionText"
      >
        <Text variant="question" experimentName={textExperimentName}>
          {heading}
        </Text>
      </Box>
      {subheading && <Html text={subheading} />}
    </>
  );
};

export default QuestionText;
